import { createApp } from 'vue'
import { createPinia } from 'pinia'

// 引入 ui-tokens：SCSS 提供变量，CSS 提供 Element Plus 主题覆盖。
import '@cms/ui-tokens/styles'
import '@cms/ui-tokens/tokens.css'

// 自托管字体：西文 Roboto（Figma 指定）+ 汉字 Noto Sans SC（跨平台一致，用户选项 B）
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/noto-sans-sc/400.css'
import '@fontsource/noto-sans-sc/500.css'
import '@fontsource/noto-sans-sc/700.css'

import 'element-plus/dist/index.css'

import App from './App.vue'
import { router } from './router'
import { installErrorCapture } from './utils/error-capture'
import { vPermission } from './directives/permission'
import { configureViewSettingsApi } from '@cms/ui/view-settings'
import { viewSettingsApi } from './api/view-settings'
import './styles/index.scss'
import './styles/element-overrides.scss'

// 视图设置服务端持久化注入：useViewSettings 初始化异步读服务端，localStorage 降级缓存
configureViewSettingsApi(viewSettingsApi)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.directive('permission', vPermission)

// 安装全局错误捕获（日志上报到 log-report 云函数）
installErrorCapture(app)

app.mount('#app')
